import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import Header from "../PackageInfo/Header";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
// import r1 from "../../Images/Raireshwar/r1.JPG";
import r2 from "../../Images/Raireshwar/r2.jpg";
import r3 from "../../Images/Raireshwar/r3.JPG";
import r4 from "../../Images/Raireshwar/r4.jpg";
import r5 from "../../Images/Raireshwar/r5.jpg";
import r6 from "../../Images/Raireshwar/r6.jpg";
import r7 from "../../Images/Raireshwar/r7.jpg";
import r8 from "../../Images/Raireshwar/r8.jpg";
import r9 from "../../Images/Raireshwar/r9.jpg";

import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";

const data = [
  {
    day: "Day 1",
    subheading: "Raireshwar Fort – Where History Meets Nature",
    schedule: [
      { time: "05:15 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:35 AM", activity: "Pick-up at Swargate." },
      { time: "05:55 AM", activity: "Pick-up at Vanaj Metro Station." },
      { time: "06:10 AM", activity: "Pick-up at Navale Bridge." },
      { time: "07:30 AM", activity: "En route breakfast. (approx)" },
      {
        time: "09:30 AM",
        activity: "Reach base village and begin trek to Raireshwar Fort.",
      },
      {
        time: "10:00 AM",
        activity: "Reach Raireshwar Plateau and explore the fort.",
      },
      {
        time: "10:00 AM",
        activity:
          "Explore the historic Raireshwar Temple, Saat Mati (seven-colored soil), scenic lakes, Pandav Leni caves, and vibrant wildflowers.",
      },
      {
        time: "02:00 PM",
        activity:
          "Enjoy local vegetarian lunch on the fort and Begin descent from Raireshwar Fort.",
      },
      {
        time: "04:30 PM",
        activity:
          "Visit British-era Jhulta Pul at Ambavade. If time permits, also visit Bhor Rajwada and Necklace Point at sunset.",
      },
      { time: "06:30 PM", activity: "Begin return journey to Pune." },
      {
        time: "09:00 PM",
        activity: "Arrival in Pune – drop at respective points.",
      },
    ],

    meals: ["Breakfast", "Lunch"],
    notes: [],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg Lunch",
      "🩺 Basic First Aid & Hydration Powder",
      "🧭 Experienced Trek Lead & Guide",
      "🌿 Entry fees",
    ],

    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Any Mineral water, Cold drinks, Personal food expenses, Extra breakfast, meals etc.",
      "Personal expenses or insurance",
    ],

    verticalCards: [
      // { title: "Rairesjwar", image: r1 },
      { title: "Rairesjwar", image: r2 },
      { title: "Rairesjwar", image: r9 },

      { title: "Rairesjwar", image: r3 },
      { title: "Rairesjwar", image: r4 },
      { title: "Rairesjwar", image: r5 },
      { title: "Rairesjwar", image: r6 },
      { title: "Rairesjwar", image: r7 },
      { title: "Rairesjwar", image: r8 },
    ],
    trekData: [
      {
        name: "Raireshwar Fort Trek",
        image: r3, // Example Unsplash image
        info: "Raireshwar Fort is a place of immense historical and natural significance. It was here, at the age of 16, that Chhatrapati Shivaji Maharaj took the sacred oath of Swarajya, marking the beginning of the Maratha Empire. The trek to Raireshwar is filled with vibrant wildflowers, especially during and after the monsoon season, making it a paradise for nature lovers. One of the most unique features of this region is the 'Saat Mati' — a rare phenomenon where seven distinct colors of soil can be seen on the same mountain. The trail offers a perfect blend of history, scenic beauty, and peaceful landscapes, making it a must-visit for trekkers and history enthusiasts alike.",
      },
    ],

    faq: [
      {
        question: "Is the Raireshwar Temple visit included?",
        answer:
          "Yes, the visit to the historic Raireshwar Temple is included. It holds great significance as the place where Chhatrapati Shivaji Maharaj took his oath of Hindavi Swarajya.",
      },
      {
        question: "What is the difficulty level of the Raireshwar Fort trek?",
        answer:
          "The trek is easy to moderate and suitable for beginners with basic fitness. The route includes a mix of steps, plateau walks, and scenic climbs.",
      },
      {
        question: "Are washrooms and changing rooms available?",
        answer:
          "Yes, washrooms and changing rooms are available at the base village. However, there are no facilities during the trek.",
      },
      {
        question: "Is this trek suitable for solo travelers?",
        answer:
          "Yes, we welcome solo trekkers. Many of our participants join solo and have a great experience.",
      },
      {
        question: "Do you have girl volunteers or trek leads?",
        answer:
          "Yes, we have female volunteers and trek leads available on our treks for added comfort and safety.",
      },
      {
        question: "Is medical assistance available?",
        answer:
          "Basic first aid will be available during the trek. Participants are advised to carry any personal medications they may require.",
      },
      {
        question: "What about extra baggage?",
        answer:
          "You can safely keep your extra bags in the bus during the trek, but please note it is at your own responsibility.",
      },
      {
        question: "What type of bus is provided?",
        answer:
          "The trek includes transportation in a NON-AC Seater Bus, which could be a 17-seater or 32-seater depending on the number of participants, ensuring decent seating comfort.",
      },
      {
        question: "What are the pickup points for the trek?",
        answer:
          "Pick-up points for the trek include Hadapsar, Swargate and Katraj.",
      },
      {
        question: "Is prior trekking experience required?",
        answer:
          "No prior trekking experience is required, but a reasonable level of fitness is recommended as the trail includes a mix of steps and mild elevation gain.",
      },
      {
        question: "Are guides provided for this trek?",
        answer:
          "Yes, experienced local trek leaders will accompany the group to ensure safety and guide you through the trail and historical spots.",
      },
      {
        question: "Is there mobile network coverage on the trail?",
        answer:
          "Network coverage is patchy, especially in remote areas. Do inform your family or friends in advance if you plan to be off-grid for a while.",
      },
      {
        question: "Are meals provided during the trek?",
        answer:
          "Yes, breakfast and lunch are usually included in the package. Carry light snacks for energy during the trek.",
      },
    ],
  },
];

const Raireshwar = () => {
  // This line seems misplaced, it should be part of the ModalTriggerList
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <TrekBasicInfo
        trekName="Reverse Waterfall & Naneghat Trek"
        location="Velhe"
        trekDifficulty="Easy"
        ageLimit="16 to 36 Years"
      />
      <PackageInclusions />
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default Raireshwar;
